import React from "react";
import { Colors } from "../../utils/colors";
import "./SectionIndicator.css";
import { TCText } from "../TCText/TCText";

type props = {
  number: string;
  color?: string;
};

export const SectionIndicator: React.FC<props> = ({ number, color }) => {
  return (
    <TCText
      style={{
        height: 24,
        width: 24,
        borderRadius: 12,
        borderColor: color ?? Colors.green,
        borderWidth: 2,
        justifyContent: "center",
        alignItems: "center",
        borderStyle: "solid",
        fontWeight: "600",
        paddingTop: 2,
        fontSize: 12,
        fontFamily: "Poppins",
        textAlign: "center",
        color: color ?? "black",
      }}
      value={number}
    />
  );
};
